/* import __COLOCATED_TEMPLATE__ from './validation-wrapper.hbs'; */
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class RequestPrescreenerValidationWrapper extends Component {
  @service intl;

  get validation() {
    return this.args.validationModel?.validations?.attrs?.value;
  }

  get errorPositionAbove() {
    return this.args.errorPositionAbove || false;
  }

  get isInvalid() {
    return this.validation?.isInvalid;
  }

  get isDirty() {
    return this.args.validationModel?.hasDirtyAttributes;
  }

  get isMessageDisplayed() {
    return this.isInvalid && this.args.forceShowValidation && this.isDirty;
  }

  get isMarkedInvalid() {
    return this.isMessageDisplayed;
  }

  get errorMessage() {
    if (this.isMessageDisplayed) {
      let { maxLength } = this.args.validationModel;
      return this.intl.t(this.validation?.message, maxLength ? { maxLength } : {});
    }
    return null;
  }

  @action
  onInput(event) {
    const value = event.target.value;
    this.args.onChange?.(this.args.question, value);
  }

  get currentAnswer() {
    return this.args.validationModel?.value;
  }

  @action
  onBlur() {
    this.args.validationModel?.validate();
  }
}
